import React from "react";
import "./registririzikarow.css";

function RegistriRizikaRow({ row, titles, redniBroj, riskGroups }) {
  const probabilityMap = {
    1: "Nizak",
    2: "Srednji",
    3: "Srednji",
    4: "Visok",
    5: "Visok",
  };

  const riskColors = {
    nizak: "#B0E0E6",
    srednji: "#FFD700",
    visok: "#FF5C5C",
  };

  const calculateTotalValue = (probability, influence) => {
    if (probability && influence) {
      const percentage = (probability + influence) * 10;
      const stringValue =
        percentage < 50 ? "nizak" : percentage > 59 ? "visok" : "srednji";
      return {
        total: probability + influence,
        percentage: `${percentage}%`,
        stringValue,
      };
    }
    return "";
  };

  const calculateControlInfluence = (probability, estimatedInfluence) => {
    if (probability && estimatedInfluence) {
      const value = (probability * estimatedInfluence) / 100;

      if (Number.isInteger(value)) {
        return value;
      } else {
        return value.toFixed(1);
      }
    } else if (probability && estimatedInfluence === 0) {
      const value = (probability * estimatedInfluence) / 100;

      if (Number.isInteger(value)) {
        return value;
      } else {
        return value.toFixed(1);
      }
    } else {
      return "";
    }
  };

  const calculatePreostaliRizik = () => {
    const cInf = calculateControlInfluence(
      row.probability_id,
      row.precaution_influence_percentage
    );

    const tot = calculateTotalValue(row.probability_id, row.influence_id).total;
    if ((tot && cInf) || (tot && cInf === 0)) {
      const preostaliRizik = (tot - cInf) * 10;
      const stringValue =
        preostaliRizik < 50
          ? "nizak"
          : preostaliRizik > 59
          ? "visok"
          : "srednji";
      return { preostaliRizik: `${preostaliRizik}%`, stringValue };
    } else {
      return;
    }
  };

  return (
    <ul className="registri-rizika-row">
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 0).width }}
      >
        {redniBroj}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 1).width,
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        {row.business_process_list?.business_process_owners.map((owner) => {
          return (
            <p key={owner.id}>
              <span style={{ marginRight: "7px" }}>{owner.first_name}</span>
              <span>{owner.last_name}</span>
            </p>
          );
        })}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 2).width }}
      >
        {row.number}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 3).width }}
      >
        {row.risk_owners.map((owner) => {
          return (
            <p key={owner.id}>
              <span style={{ marginRight: "7px" }}>{owner.first_name}</span>
              <span>{owner.last_name}</span>
            </p>
          );
        })}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 4).width,
          backgroundColor: "#FFD700",
          color: "#000",
        }}
      >
        {row.name}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 5).width,
          flexDirection: "column",
        }}
      >
        <div
          style={{
            marginBottom: "5px",
            wordWrap: "break-word",
            width: "100%",
          }}
        >
          <span style={{ marginRight: "5px", fontWeight: "bold" }}>
            Opis rizika:
          </span>
          <span>{row.description}</span>
        </div>
        <div
          style={{ marginBottom: "5px", wordWrap: "break-word", width: "100%" }}
        >
          <span style={{ marginRight: "5px", fontWeight: "bold" }}>Uzrok:</span>
          <span>{row.cause}</span>
        </div>
        <div style={{ wordWrap: "break-word", width: "100%" }}>
          <span style={{ marginRight: "5px", fontWeight: "bold" }}>
            Posledice:
          </span>
          <span>{row.effect}</span>
        </div>
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 6).width }}
      >
        {row?.risk_group ? row?.risk_group.name : "grupa rizika"}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 7).width,
          display: "flex",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "50%",
            borderRight: "var(--mainBorder)",
            height: "100%",
            padding: "5px",
          }}
        >
          {row.probability_id}
        </div>
        <div
          style={{
            width: "50%",
            padding: "5px",
            height: "100%",
          }}
        >
          {probabilityMap[row.probability_id]}
        </div>
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 8).width,
          display: "flex",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "50%",
            borderRight: "var(--mainBorder)",
            height: "100%",
            padding: "5px",
          }}
        >
          {row.probability_id}
        </div>
        <div
          style={{
            width: "50%",
            padding: "5px",
            height: "100%",
          }}
        >
          {probabilityMap[row.influence_id]}
        </div>
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 9).width,
          display: "flex",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "33%",
            borderRight: "var(--mainBorder)",
            height: "100%",
            padding: "5px",
          }}
        >
          {calculateTotalValue(row.probability_id, row.influence_id).total}
        </div>
        <div
          style={{
            width: "33%",
            padding: "5px",
            height: "100%",
            borderRight: "var(--mainBorder)",
          }}
        >
          {calculateTotalValue(row.probability_id, row.influence_id).percentage}
        </div>
        <div
          style={{
            flex: "1",
            padding: "5px",
            height: "100%",
            backgroundColor:
              riskColors[
                calculateTotalValue(row.probability_id, row.influence_id)
                  ?.stringValue
              ],
          }}
        >
          {
            calculateTotalValue(row.probability_id, row.influence_id)
              ?.stringValue
          }
        </div>
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 10).width }}
      >
        {row.management_method}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 11).width,
          wordWrap: "break-word",
        }}
      >
        {row.management_method_precaution_description}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 12).width }}
      >
        {row.precaution_influence_percentage}%
      </li>
      <li
        className="registri-rizika-row-item"
        style={{ width: titles.find((title) => title.id === 13).width }}
      >
        {calculateControlInfluence(
          row.probability_id,
          row.precaution_influence_percentage
        )}
      </li>
      <li
        className="registri-rizika-row-item"
        style={{
          width: titles.find((title) => title.id === 14).width,
          display: "flex",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "50%",
            borderRight: "var(--mainBorder)",
            height: "100%",
            padding: "5px",
          }}
        >
          {calculatePreostaliRizik()?.preostaliRizik}
        </div>
        <div
          style={{
            width: "50%",
            padding: "5px",
            height: "100%",
            backgroundColor: riskColors[calculatePreostaliRizik()?.stringValue],
          }}
        >
          {calculatePreostaliRizik()?.stringValue}
        </div>
      </li>
    </ul>
  );
}

export default RegistriRizikaRow;
